import { batchActions } from "redux-batched-actions";
import { 
    SET_ERROR_LOGIN,  
    setErrorLogin, 
    //UPDATE_ACCOUNT, 
    updateSpaData, 
    updateSpaDataWithNotify 
} from "./CurrentAccount";
import { fetchWrapper as fetch, fetchWithSpinner } from "../utils/fetch";
import urls from "../apiUrls";

export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';

export const openMenu = (count, notifications, isNavigatingToLandingOnClose = false) => ({
    count: count,
    notifications: notifications,
    type: OPEN_MENU,
    isNavigatingToLandingOnClose,
})

export const closeMenu = () => ({
    type: CLOSE_MENU,
})

export const showNotification = () => {
    // Notification on Windows from Browser from our site
    Notification.requestPermission()
    .then(permission => {
        if (permission === 'granted') {
            new Notification('TankiMods.Net. У Вас есть новые оповещения')
        }
    })
}

/* get user data from server lesta id and add it to state */
export const fetchNotifications = (userData) => {
    return (dispatch, getState) => {
        const state = getState();

        const url = `https://tankimods.net`+urls.userNotifications

        //dispatch(startFetching()) //dispatch(startLogin())
        
        const fetchPromise = fetch(url, {method: 'POST', body: userData}).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorLogin(rawResponseData.context),
                        //stopFetching(),
                    ], SET_ERROR_LOGIN))
                } else {
                    if (typeof(rawResponseData.notifications) === 'undefined') {
                        /*dispatch(batchActions([
                            updateSpaData(rawResponseData, state),
                            //stopFetching(),
                        ], UPDATE_ACCOUNT))*/
                        dispatch(updateSpaData(rawResponseData, state))
                    } else {
                        /*dispatch(batchActions([
                            updateSpaDataWithNotify(rawResponseData, state),
                            //stopFetching(),
                        ], UPDATE_ACCOUNT))*/
                        dispatch(updateSpaDataWithNotify(rawResponseData, state))
                        /*dispatch(batchActions([
                        updateSpaDataWithNotify(rawResponseData, state),
                        showNotification()
                        ], UPDATE_ACCOUNT))*/
                    }
                }
            })
            .catch((errorData) => {
                dispatch(batchActions([
                    setErrorLogin(errorData),
                    //stopFetching(),
                ], SET_ERROR_LOGIN))
            })
        return fetchPromise // fetchWithSpinner(dispatch, fetchPromise);
    }
}

export const onChangeNotifyActive = (objectId, method, userData, type) => {
    return (dispatch, getState) => {
        let body, url

        url = `https://tankimods.net/api/users/notifications/` //+urls.subscriptionAction+`?id=${id}/
        body = {
            type: type,
            ticketId: objectId,
            spaUsername: userData.spaUsername,
            spaId: userData.spaId,
        }
        /*if (type === 'report') {
            url = `https://tankimods.net/api/users/notifications/?type=report` //`${urls.subscriptionAction}`
            body = {
                type: type,
                ticketId: objectId,
                spaUsername: userData.spaUsername,
                spaId: userData.spaId,
            }
        } else {
            url = `https://tankimods.net/api/users/notifications/?type=support` //+urls.subscriptionAction+`?id=${id}/
            body = {
                type: type,
                ticketId: objectId,
                spaUsername: userData.spaUsername,
                spaId: userData.spaId,
            }
        }*/
        const fetchPromise = fetch(url, { method, body }).promise
        return fetchWithSpinner(dispatch, fetchPromise)
        /*const state = getState();

        const url = `https://tankimods.net/api/users/notifications/`
        
        const fetchPromise = fetch(url, {method: 'UPDATE', body: userData}).promise
            .then((rawResponseData) => {
                debugger
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorLogin(rawResponseData.context),
                        //stopFetching(),
                    ], SET_ERROR_LOGIN))
                } else {
                    dispatch(batchActions([
                        updateSpaDataWithNotify(rawResponseData, state),
                        //stopFetching(),
                    ], UPDATE_ACCOUNT))
                }
            })
            .catch((errorData) => {
                dispatch(batchActions([
                    setErrorLogin(errorData),
                    //stopFetching(),
                ], SET_ERROR_LOGIN))
            })
        return fetchPromise*/
    }
}

export const ignoreReportUpdate = (ticketId, userData, id) => {
    return onChangeNotifyActive(ticketId, 'UPDATE', userData, 'report')
}
export const ignoreSupportUpdate = (ticketId, userData, id) => {
    return onChangeNotifyActive(ticketId, 'UPDATE', userData, 'support')
}